/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeckValidationDTO
 */
export interface DeckValidationDTO {
    /**
     * 
     * @type {string}
     * @memberof DeckValidationDTO
     */
    deckId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeckValidationDTO
     */
    validationErrors: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DeckValidationDTO
     */
    isValid: boolean;
}

/**
 * Check if a given object implements the DeckValidationDTO interface.
 */
export function instanceOfDeckValidationDTO(value: object): value is DeckValidationDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('validationErrors' in value) || value['validationErrors'] === undefined) return false;
    if (!('isValid' in value) || value['isValid'] === undefined) return false;
    return true;
}

export function DeckValidationDTOFromJSON(json: any): DeckValidationDTO {
    return DeckValidationDTOFromJSONTyped(json, false);
}

export function DeckValidationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeckValidationDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'validationErrors': json['validationErrors'],
        'isValid': json['isValid'],
    };
}

export function DeckValidationDTOToJSON(json: any): DeckValidationDTO {
    return DeckValidationDTOToJSONTyped(json, false);
}

export function DeckValidationDTOToJSONTyped(value?: DeckValidationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'validationErrors': value['validationErrors'],
        'isValid': value['isValid'],
    };
}

